// News 页面相关的翻译资源
export const newsResources = {
  zh: {
    // News page
    "news.title": "新闻中心",
    "news.categories": "分类",
    "news.category.all": "全部",
    "news.category.fertility": "促进生育",
    "news.category.education": "扶贫兴教",
    "news.category.poverty": "倡导家善",
    "news.empty": "暂无内容 敬请期待",
    
    // News Detail page
    "newsDetail.title": "新闻详情",
    "newsDetail.notFound": "未找到该新闻",
    "newsDetail.backToList": "返回新闻列表",
  },
  zh_TW: {
    // News page
    "news.title": "新聞中心",
    "news.categories": "分類",
    "news.category.all": "全部",
    "news.category.fertility": "促進生育",
    "news.category.education": "扶貧興教",
    "news.category.poverty": "宣導家善",
    "news.empty": "暫無內容 敬請期待",
    
    // News Detail page
    "newsDetail.title": "新聞詳情",
    "newsDetail.notFound": "未找到該新聞",
    "newsDetail.backToList": "返回新聞列表",
  },
  en: {
    // News page
    "news.title": "News Center",
    "news.categories": "Categories",
    "news.category.all": "All",
    "news.category.fertility": "Promote Childbirth",
    "news.category.education": "Poverty Alleviation and Educational Promotion",
    "news.category.poverty": "Promote Family Virtues",
    "news.empty": "No content available, please stay tuned",
    
    // News Detail page
    "newsDetail.title": "News Detail",
    "newsDetail.notFound": "News not found",
    "newsDetail.backToList": "Back to News List",
  }
};

